import ScrollAnime from "./anime/scroll.es6";
import Anchor from "./ui/anchor.es6";
import Accordion from "./ui/accordion.es6";
import Modal from "./ui/modal.es6";

export default class Main {
    constructor() {
        this._init();
    }

    _init() {
        this.scroll = new ScrollAnime();
        this.anchor = new Anchor();
        this.accordion = new Accordion();
        this.modal = new Modal();

        setTimeout(()=>{
            document.body.classList.add('-ready');
        }, 1000);
    }
}
